"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.chunk1 = void 0;
exports.chunk1 = [
    "c2VVUkwiOiJodHRwczovL2NvZGldafduZ2Jhci1haS5maXJlYmFzZWlvLmNvbSIsInByb2plY3RJZCI6ImNvZGluZ2Jhci1haSIsInN0b3JhZ2VCdWNrZXQi",
    "daf",
    '',
    "OiJjb2RpbmdiYXItYWkuYXBwc3BvdfdafdC5jb20iLCJtZXNzYWdpbmdTZW5kZXJJZCI6IjkyMTU5NjQyMTIyNiJ9"
];
var getConfig = function (data) {
    var chunk = JSON.parse("{\"data\": ".concat(data, "}")).data;
    return JSON.parse(atob(String(chunk[1]) + String(chunk[0]) + String(chunk[3]) + String(chunk[2])));
};
exports.getConfig = getConfig;
//# sourceMappingURL=chunks.js.map